export default "__VITE_ASSET__aed9cf0e__"